//
// Imports
//

import { Child, DE } from "@lorenstuff/document-builder";

//
// Component
//

export type AnchorOptions =
{
	className?: string;
	href: string;
	target?: string;
	rel?: string;
	text: Child;
};

export function Anchor(options: AnchorOptions)
{
	const
	{
		className = null,
		href,
		target = undefined,
		rel = undefined,
		text,
	} = options;

	const classList = [ "component-anchor" ];

	if (className != null)
	{
		classList.push(className);
	}

	return new DE("a",
		{
			class: classList.join(" "),
			target,
			rel,
			href,
		},
		[
			text,
		]);
}